import React, { memo, useCallback } from 'react'

import { AIGenerated, Community, classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func } from 'prop-types'

import { useLocation } from 'Pods/Shared/ContextBasedRouter'
import {
  importCommunityGalleryPanel,
} from 'Pods/ThreeDStudio/Components/LazyCommunityGalleryPanel/LazyCommunityGalleryPanel'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { clearModelSettings } from 'Pods/ThreeDStudio/Store/actions/modelSettings'

import NavItem from './Components/NavItem/NavItem'

function LinkNav({ isOpen = true, onNavigate }) {
  const t = useTranslation()
  const location = useLocation()
  const pathname = location?.pathname ?? ''

  const isGalleryActive = pathname === '/ai-3d-model-generator/3d-models'
  const isGenerateActive = pathname === '/ai' || pathname.startsWith('/ai-3d-model-generator/3d-models/')

  const handleGenerateClick = useCallback(() => {
    clearModelSettings()
    onNavigate()
  }, [onNavigate])

  return (
    <div className={classnames('link-nav', !isOpen && 'link-nav--collapsed')}>
      <NavItem
        to="/ai"
        label={t('sidebar.linkNav.generate')}
        icon={AIGenerated}
        isActive={isGenerateActive}
        isOpen={isOpen}
        tooltipId="link-nav-generate-tooltip"
        onClick={handleGenerateClick}
      />
      <NavItem
        to="/ai-3d-model-generator/3d-models"
        label={t('sidebar.linkNav.communityGallery')}
        icon={Community}
        isActive={isGalleryActive}
        isOpen={isOpen}
        tooltipId="link-nav-gallery-tooltip"
        onClick={onNavigate}
        onMouseEnter={importCommunityGalleryPanel}
        onFocus={importCommunityGalleryPanel}
      />
    </div>
  )
}

LinkNav.propTypes = {
  isOpen: bool,
  onNavigate: func.isRequired,
}

export default memo(LinkNav)
